<template>
    <div class="services container-fluid h-100 pt-3">
        <div class="row h-100 m-0">
            <div class="col-12 p-lg-0 mx-3 mx-lg-0 mb-3">
                <div class="card bg-light border-0 shadow-sm h-100">
                    <div class="card-header bg-white d-flex flex-nowrap justify-content-between align-items-center font-weight-bolder pl-2 pr-1 py-1">
                        <div>
                            橫幅一覽
                        </div>
                        <div class="d-flex flex-nowrap align-items-center">
                            <b-form-checkbox class="mr-3"
                                             switch
                                             v-model="isReordering"
                                             v-on:change="dragEnded">
                                排列橫幅
                            </b-form-checkbox>
                            <button class="btn btn-sm btn-light border"
                                    v-on:click="isModalBannerOpen = true">
                                <font-awesome-icon class="mr-1"
                                                   icon="plus-square">
                                </font-awesome-icon>新增橫幅
                            </button>
                        </div>
                    </div>
                    <div class="position-relative h-100">
                        <div class="position-absolute empty-notice"
                             v-if="banners.length === 0">
                            <h1 class="display-4 text-center mb-0">
                                <font-awesome-icon v-bind:icon="['fad', 'ad']"></font-awesome-icon>
                            </h1>
                            <p class="font-weight-bolder text-center">
                                暫無橫幅
                            </p>
                        </div>
                        <draggable class="row m-0"
                                   v-bind:disabled="!isReordering"
                                   v-model="bannersInComponent">
                            <banner-thumbnail class="col-md-6 col-lg-4 col-xl-3"
                                              v-for="banner in bannersInComponent"
                                              v-bind:key="banner._id"
                                              v-bind:is-reordering="isReordering"
                                              v-bind:banner="banner">
                            </banner-thumbnail>
                        </draggable>
                    </div>
                </div>
            </div>
        </div>

        <modal-banner v-model="isModalBannerOpen"></modal-banner>
    </div>
</template>

<script>
import { BFormCheckbox, } from "bootstrap-vue";

import Draggable from "vuedraggable";

import ModalBanner from "../components/Banners/ModalBanner";
import BannerThumbnail from "../components/Banners/BannerThumbnail";

export default {
    name: "Banner",
    components: {
        BFormCheckbox,
        Draggable,
        BannerThumbnail,
        ModalBanner,
    },
    data () {
        return {
            isReordering: false,
            isModalBannerOpen: false,

            bannersInComponent: [],
        };
    },
    computed: {
        banners () {
            return this.$store.getters["banner/banners"];
        },
    },
    methods: {
        async dragEnded (evt) {
            if (!evt) {
                try {
                    await Promise.all(
                        this.bannersInComponent
                            .slice(0)
                            .map(
                                async ({ _id, order }, ind) => {
                                    if (order !== ind) {
                                        return this.$store.dispatch(
                                            "banner/edit",
                                            {
                                                _id,
                                                "order": ind
                                            }
                                        );
                                    }
                                    return undefined;
                                }
                            )
                    );
                } catch (e) {
                    console.error(e);
                }
            }
        },
    },
    mounted () {
        if (
            Array.isArray(this.banners) &&
            this.banners.length > 0
        ) {
            this.bannersInComponent = this.banners;
        }
    },
    watch: {
        "banners" (newVal) {
            if (
                Array.isArray(newVal) &&
                newVal.length > 0
            ) {
                this.bannersInComponent = newVal;
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.empty-notice {
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
}
</style>
